import initOrderForm from '../shared/orderForm';
import initMap from './map';

interface ContactsConfig {
  lang: string;
  contacts: {
    apiKey: string;
    markerIcon: string;
    markerPosition: {
      lat: number;
      lng: number
    };
  };
  content: {
    order: Parameters<typeof initOrderForm>[0]['content'];
  };
}

const initContacts = ({
  lang,
  contacts,
  content
}: ContactsConfig): void => {
  initMap(lang, contacts, 2000);

  const onSuccess = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'send_request', { event_category: 'contacts' });
    }
  };

  initOrderForm({
    content: content.order,
    onSuccess
  });
};

export default initContacts;
